// Hair Care Section Carousel JavaScript
document.addEventListener('DOMContentLoaded', function() {
    // Lazy load images and videos
    const lazyImages = document.querySelectorAll('.theog-embla img.lazy-image');
    const lazyVideos = document.querySelectorAll('.theog-embla video.lazy-video');

    if ('IntersectionObserver' in window) {
        // Image lazy loading observer
        const imageObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (img.dataset.src) {
                        img.src = img.dataset.src;
                        delete img.dataset.src;
                        img.classList.remove('lazy-image');
                        imageObserver.unobserve(img);
                    }
                }
            });
        }, { rootMargin: '50px' });

        // Video lazy loading observer
        const videoObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const video = entry.target;
                    const sources = video.querySelectorAll('source[data-src]');

                    sources.forEach(source => {
                        source.src = source.dataset.src;
                        delete source.dataset.src;
                    });

                    if (sources.length > 0) {
                        video.load();
                        video.play().catch(err => {
                            console.warn('Autoplay prevented:', err);
                        });
                        video.classList.remove('lazy-video');
                        videoObserver.unobserve(video);
                    }
                }
            });
        }, { rootMargin: '50px' });

        lazyImages.forEach(img => imageObserver.observe(img));
        lazyVideos.forEach(video => videoObserver.observe(video));
    } else {
        // Fallback for browsers without IntersectionObserver
        lazyImages.forEach(img => {
            if (img.dataset.src) {
                img.src = img.dataset.src;
                delete img.dataset.src;
            }
        });

        lazyVideos.forEach(video => {
            const sources = video.querySelectorAll('source[data-src]');
            sources.forEach(source => {
                source.src = source.dataset.src;
                delete source.dataset.src;
            });
            video.load();
            video.play().catch(err => {
                console.warn('Autoplay prevented:', err);
            });
        });
    }

    // Check if Embla Carousel is available
    if (typeof EmblaCarousel === 'undefined') {
        console.warn('Embla Carousel not loaded');
        return;
    }

    // Initialize Embla Carousel
    const emblaNode = document.querySelector('.theog-embla__viewport');
    if (!emblaNode) return;

    const options = {
        loop: true,
        align: 'start',
        slidesToScroll: 1,
        containScroll: 'trimSnaps',
    };

    const emblaApi = EmblaCarousel(emblaNode, options);

    // Auto-scroll every 5 seconds
    let autoScrollInterval = setInterval(() => {
        if (emblaApi.canScrollNext()) {
            emblaApi.scrollNext();
        } else {
            emblaApi.scrollTo(0);
        }
    }, 5000);

    // Pause auto-scroll on user interaction
    emblaNode.addEventListener('mouseenter', () => {
        clearInterval(autoScrollInterval);
    });

    emblaNode.addEventListener('mouseleave', () => {
        autoScrollInterval = setInterval(() => {
            if (emblaApi.canScrollNext()) {
                emblaApi.scrollNext();
            } else {
                emblaApi.scrollTo(0);
            }
        }, 5000);
    });
});
